import { Injectable } from '@angular/core';
import { ICedroServicesLoggable } from '@services/strategy-pattern-login/iCedroServices-loggable';

@Injectable({
  providedIn: 'root'
})
export class ICedroServicesWso2Service implements ICedroServicesLoggable {

  constructor() { }

  contextInfoUser(usermame: string, password: string) {
    throw new Error('Method not implemented.');
  }

  clearContextInfoUser() {
    throw new Error('Method not implemented.');
  }

}
